// extracted by mini-css-extract-plugin
export var accordion = "_hq-0";
export var chevron = "_hq-3";
export var closed = "_hq-2";
export var content = "_hq-4";
export var open = "_hq-1";
export var rotate = "_hq-5";